import { createBrowserRouter, Link, Navigate, NavigationType, NavLink, RouteObject, UNSAFE_NavigationContext } from "react-router-dom";
import ActivityDashboard from "../../features/activities/dashboard/ActivityDashboard";
import ActivityDetails from "../../features/activities/details/ActivityDetails";
import ActivityForm from "../../features/activities/form/ActivityForm";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import TestErrors from "../../features/errors/TestError";
import HomePage from "../../features/home/HomePage";
import ProfilePage from "../../features/profiles/ProfilePage";
import LoginForm from "../../features/users/LoginForm";
import App from "../layout/App";
import RequireAuth from "./RequireAuth";
import RegisterSuccess from "../../features/users/RegisterSuccess";
import ConfirmEmail from "../../features/users/ConfirmEmail";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            // //{ path: '', element: <HomePage /> },
            // { path: 'activities', element: <ActivityDashboard /> },
            // { path: 'activities/:id', element: <ActivityDetails /> },

            // //{ path: 'createActivity', element: <ActivityForm /> },
            // { path: 'createActivity', element: <ActivityForm key='create' /> },

            // //{ path: 'manage/:id', element: <ActivityForm /> }
            // { path: 'manage/:id', element: <ActivityForm key='manage' /> },
            // //{ path: 'login', element: <LoginForm />}, //'n nn >> we have model for that
            // { path: 'profiles/:id', element: <h1></h1> },

            // { path: 'errors', element: <TestErrors /> },
            // { path: 'not-found', element: <NotFound /> },
            // { path: 'server-error', element: <ServerError /> },
            // { path: '*', element: <Navigate replace to='/not-found' /> },

            {element: <RequireAuth />, children: [ //'n
                //{ path: '', element: <HomePage /> },
                { path: 'activities', element: <ActivityDashboard /> },
                { path: 'activities/:id', element: <ActivityDetails /> },

                //{ path: 'createActivity', element: <ActivityForm /> },
                { path: 'createActivity', element: <ActivityForm key='create' /> },

                //{ path: 'manage/:id', element: <ActivityForm /> }
                { path: 'manage/:id', element: <ActivityForm key='manage' /> },

                //{ path: 'login', element: <LoginForm />}, //'n nn >> we have model for that
                // { path: 'profiles/:id', element: <h1></h1> },
                { path: 'profiles/:username', element: <ProfilePage />},

                { path: 'errors', element: <TestErrors /> },
            ]},

            { path: 'not-found', element: <NotFound /> },
            { path: 'server-error', element: <ServerError /> },
            { path: 'account/registerSuccess', element: <RegisterSuccess /> }, //'n
            { path: 'account/verifyEmail', element: <ConfirmEmail /> }, //'n
            { path: '*', element: <Navigate replace to='/not-found' /> },
        ]
    }
]

export const router = createBrowserRouter(routes);